<div class="paginator_container">
  <div>
    Mostrando de {{_itemRangeFrom}} até {{_itemRangeTo}} de {{totalItems}} registros
  </div>
  <div>
    <nav aria-label="Page navigation">
      <ul class="pagination justify-content-end">
        <li class="page-item"><a class="page-link" (click)="FirstPage()">Primeiro</a></li>
        <li class="page-item" *ngIf="_numPage >= 2"><a class="page-link" (click)="PreviousPage()">Anterior</a></li>
        <li class="page-item" [ngClass]="{'active' : _stButton == _numPage}"><a class="page-link" (click)="GoToPage(_stButton)">{{ _stButton }}</a></li>
        <li class="page-item" [ngClass]="{'active' : _ndButton == _numPage}" *ngIf="totalPages > 1"><a class="page-link" (click)="GoToPage(_ndButton)">{{ _ndButton }}</a></li>
        <li class="page-item" [ngClass]="{'active' : _thButton == _numPage}" *ngIf="totalPages > 2"><a class="page-link" (click)="GoToPage(_thButton)">{{ _thButton }}</a></li>
        <li class="page-item" *ngIf="_numPage < totalPages"><a class="page-link" (click)="NextPage()">Próximo</a></li>
        <li class="page-item"><a class="page-link" (click)="LastPage()">Última</a></li>
      </ul>
    </nav>
  </div>
    
</div>
